import type { TagOption } from 'components/shared/Tags/model';
import type { Underlying } from 'models/underlying';
import type { UnderlyingCodeType } from 'models/underlying/base';
import { getUnderlyingCode } from 'utils/underlying/underlying-code';

export function translateUnderlyingToTagOption(
  underlying: Underlying,
  defaultUnderlyingCodeType: UnderlyingCodeType,
): TagOption<Underlying> {
  return {
    rawValue: underlying,
    label: getUnderlyingCode(underlying, defaultUnderlyingCodeType),
    value: underlying.id,
  };
}
